/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-27 10:55:33
 **/

import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
//*
import { SoundMeter } from "@/frameworks/core/engine";
/*/
import { SoundMeter } from "@rfice/xms";
//*/

const PhoneDetail = atom<PushServices.Call.PhoneDetailProps>({
	callerID: "",
	callees: [],
	tabID: "",
	callID: ""
});

const BusyUsers = atom<string[]>([]);

const CallList = atom<PushServices.Call.CallList>({});
const Callees = atom<WebServices.User.UserInfo[]>([]);
const Popup = atom<Record<string, PushServices.Call.PhoneCallPortalItem>>({});
// const LocalStream = atom<MediaStream | null>(null);
const LocalSoundMeter = atom<SoundMeter | null>(null);
const RemoteStreams = atom<PushServices.Call.UserStreams>({});
const RemoteScreenStream = atom<MediaStream | null>(null);

const Call = atomFamily((callID: string) =>
	atom(
		(get) => get(CallList)[callID] ?? {},
		(_, set, update: JotaiArgument<PushServices.Call.Info>) => {
			set(CallList, (prev) => ({
				...prev,
				[callID]: {
					...prev[callID],
					...(typeof update === "function" ? update(prev[callID]) : update)
				}
			}));
		}
	)
);

const CallStatus = atomFamily((callID: string) =>
	atom(
		(get) => get(Call(callID))?.status ?? "",
		(_, set, update: JotaiArgument<PushServices.Call.CallStatus>) => {
			set(Call(callID), (prev) => ({
				...prev,
				status: typeof update === "function" ? update(prev.status) : update
			}));
		}
	)
);

const CallTime = atomFamily((callID: string) =>
	atom(
		(get) => get(Call(callID))?.time ?? -1,
		(get, set, update: JotaiArgument<number>) => {
			try {
				const call = get(Call(callID)) ?? null;
				call &&
					set(Call(callID), (prev) => ({
						...prev,
						time: typeof update === "function" ? update(prev.time ?? -1) : update
					}));
			} catch {
				// ignore
			}
		}
	)
);

const RecordTime = atomFamily((callID: string) =>
	atom(
		(get) => get(Call(callID))?.recordTime ?? 0,
		(get, set, update: JotaiArgument<number>) => {
			try {
				const call = get(Call(callID)) ?? null;
				call &&
					set(Call(callID), (prev) => ({
						...prev,
						recordTime: typeof update === "function" ? update(prev.recordTime ?? 0) : update
					}));
			} catch {
				// ignore
			}
		}
	)
);

const CallUsers = atomFamily((callID: string) =>
	atom(
		(get) => get(Call(callID))?.callUsers ?? null,
		(_, set, update: JotaiArgument<PushServices.Call.UserInfos>) => {
			set(Call(callID), (prev) => ({
				...prev,
				callUsers: {
					...prev.callUsers,
					...(typeof update === "function" ? update(prev.callUsers) : update)
				}
			}));
		}
	)
);

const RemoteStream = atomFamily((userID: string) =>
	atom(
		(get) => get(RemoteStreams)[userID],
		(_, set, update: MediaStream | null) => {
			set(RemoteStreams, (prev) => ({
				...prev,
				[userID]: update
			}));
		}
	)
);

const PhoneCallAtoms = {
	PhoneDetail,
	Popup,

	// LocalStream,
	LocalSoundMeter,
	RemoteStream,
	RemoteScreenStream,

	CallList,
	Callees,
	Call,
	CallStatus,
	CallTime,
	CallUsers,
	BusyUsers,
	RecordTime
};
export default PhoneCallAtoms;
